import React from 'react';
import './ExternalSign.css';

export default function Success() {
  return (
    <div className="external-sign-container">
      <header className="header">
        <h1>Process Complete</h1>
        <div className="stepper">
          <div className="step"><span className="step-num">1</span> Create Signature</div>
          <div className="step-line"></div>
          <div className="step"><span className="step-num">2</span> Place Signature</div>
          <div className="step-line"></div>
          <div className="step active"><span className="step-num">3</span> Complete</div>
        </div>
      </header>

      <main className="content">
        <div className="success-screen">
          <div className="success-icon-container">✓</div>
          <h1>Document Signed Successfully!</h1>
          <p>Thank you for using our Digital Sign System.</p>
          <p style={{ marginTop: '1rem' }}>Your document has been signed and saved successfully. A copy of the signed document will be shared with you via email shortly.</p>
        </div>
      </main>
    </div>
  );
}
